import React from "react";
import { motion, Variants } from "framer-motion";
import missions from "../../images/gim.jpg";

// Animation factory
const fadeUp = (delay: number = 0): Variants => ({
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { delay, duration: 0.8, ease: "easeInOut" },
    },
});

const Post = () => {
    return (
        <div className="bg-deepGreen min-h-[100vh] flex flex-col justify-center items-center xl:px-48 md:px-24 sm:px-16 px-8 py-32">
            <div className="flex lg:flex-row flex-col justify-center xl:gap-x-16 gap-x-8 gap-y-16">
                {/* Image */}
                <motion.div
                    className="lg:basis-1/2 flex justify-center items-center"
                    variants={fadeUp(0.2)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <img src={missions} alt="Missions" className="xl:w-[500px] w-[400px]" />
                </motion.div>

                {/* Text */}
                <motion.div
                    className="lg:basis-1/2"
                    variants={fadeUp(0.4)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <p className="text-white leading-[30px] lg:text-left text-justify">
                        One of the most outstanding truths of scripture was most perfectly
                        captured by John the Apostle: <br /> And the Word was made flesh, and
                        dwelt among us... John 1:14 KJV <br />
                        Encapsulated in these words is the very heart and passion of the
                        Father in His love towards mankind. That God, infinite and eternal,
                        would relinquish His divinity to identify and dwell with mortal man
                        within space and time — that is the greatest story of the ages! <br />
                        For the Son of man is come to seek and to save that which was lost.
                        Luke 19:10 KJV <br />
                        It is for this reason that He crossed unknown waters. <br />
                        He paved a way through unidentified territories so that He could be
                        among men.
                    </p>
                </motion.div>
            </div>

            {/* Button area */}
            <motion.div
                className="mt-16"
                variants={fadeUp(0.6)}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                {/* <button className="font-montserrat border-2 text-white md:text-base text-sm border-white rounded-md font-semibold py-2 px-10 tracking-[2px]">
                    GO TO POST
                </button> */}
            </motion.div>
        </div>
    );
};

export default Post;
